import { Box } from "@mui/material";
import RpisPage from "../RpisPage/RpisPage";
import { useIntl } from "react-intl";
import Messages from "../../localization/Messages";
import "./StatisticsPage.css";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../store/configureStore";
import { useFetchDispAddresses } from "../../hooks/useFetchDispAddresses";
import { buildDispAddressesPayload } from "../DispManageAddresses/DispManageAddresses";
import { searchParamsInit } from "../../models/searchParams";
import { AddressType } from "../../models/address";
import { useCachedDocks } from "../../hooks/useCachedDocks";
import { Analytics } from "./components/Analytics/Analytics";
import { StatisticsFilters as StatisticsFiltersType } from "./shared/filters";
import { StatisticsFilters } from "./components/StatisticsFilters/StatisticsFilters";
import useFetchShips from "../ManageBookings/hooks/useFetchShips";
import { dashboardStatsInit } from "../../models/stats";
import { useGuiConfState } from "../../hooks/useGuiConfState";
import { useFetchDashboardStats } from "./hooks/useFetchDashboardStats";

export const StatisticsPage = () => {
    const intl = useIntl();
    const managingCompanies = useSelector((s: AppState) => s.managingCompanies).data;
    const { docks } = useCachedDocks();
    const [filters, setFilters] = useGuiConfState("dispStatistics");
    const { data: dashboardStatsData } = useFetchDashboardStats({ filters });
    const dashboardStats = dashboardStatsData ?? dashboardStatsInit;

    const { data: addressData } = useFetchDispAddresses(
        buildDispAddressesPayload({
            ...searchParamsInit,
            addressType: AddressType.OwningCompany,
            order: ["company asc"],
            addressSource: undefined,
            status: undefined,
            rowsPerPage: 0,
            page: 0,
        }),
    );
    const owningCompanies = useMemo(() => addressData?.addresses ?? [], [addressData]);
    const [ships] = useFetchShips();

    const onChangeFilters = (diff: Partial<StatisticsFiltersType>) => {
        setFilters(diff);
    };

    return (
        <RpisPage
            title={intl.formatMessage(Messages.overviewOfStatistics)}
            className="statistics-page-container"
        >
            <Box className="statistics-kpi>">
                <Box ml={7} mt={5}>
                    <StatisticsFilters
                        managingCompanies={managingCompanies}
                        owningCompanies={owningCompanies}
                        docks={docks}
                        filters={filters}
                        setFilters={onChangeFilters}
                        ships={ships}
                    />
                </Box>
                <Analytics docks={docks} dashboardStats={dashboardStats} />
            </Box>
        </RpisPage>
    );
};

export default StatisticsPage;
